import { render, staticRenderFns } from "./gameNav.vue?vue&type=template&id=40d88023&scoped=true&"
import script from "./gameNav.vue?vue&type=script&lang=js&"
export * from "./gameNav.vue?vue&type=script&lang=js&"
import style0 from "./gameNav.vue?vue&type=style&index=0&id=40d88023&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d88023",
  null
  
)

export default component.exports